// import React, { useState, useMemo } from "react";
// import styles from "../../assets/scss/InventoryManagement/PriceCategory.module.scss";
// import Pagination from "../../Components/Common/Pagination";

// const PreBookedOrders = () => {
//   const [currentPage, setCurrentPage] = useState(1);
//   const [limit, setLimit] = useState(10);

//   // 🔥 Static Data
//   const staticData = [
//     { id: 1, productName: "Rice", quantity: 120 },
//     { id: 2, productName: "Wheat", quantity: 95 },
//     { id: 3, productName: "Sugar", quantity: 60 },
//     { id: 4, productName: "Salt", quantity: 40 },
//     { id: 5, productName: "Oil", quantity: 150 },
//     { id: 6, productName: "Dal", quantity: 80 },
//     { id: 7, productName: "Maida", quantity: 70 },
//     { id: 8, productName: "Ragi", quantity: 55 },
//     { id: 9, productName: "Corn", quantity: 110 },
//     { id: 10, productName: "Chilli", quantity: 30 },
//     { id: 11, productName: "Turmeric", quantity: 45 },
//   ];

//   // 🔥 Pagination Logic
//   const totalPages = Math.ceil(staticData.length / limit);

//   const paginatedData = useMemo(() => {
//     const start = (currentPage - 1) * limit;
//     return staticData.slice(start, start + limit);
//   }, [currentPage, limit]);

//   return (
//     <div className={styles.inventoryContainer}>
//       <div className={styles.inventoryContainers}>
//         <div className={styles.tableWrapper}>
//           <table>
//             <thead>
//               <tr>
//                 <th>SR No</th>
//                 <th>Product Name</th>
//                 <th>Quantity (kg)</th>
//               </tr>
//             </thead>

//             <tbody>
//               {paginatedData.length > 0 ? (
//                 paginatedData.map((item, index) => (
//                   <tr key={item.id}>
//                     <td>{(currentPage - 1) * limit + index + 1}</td>
//                     <td>{item.productName}</td>
//                     <td>{item.quantity} kg</td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan="3" style={{ textAlign: "center" }}>
//                     No data found
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>

//         {/* 🔥 Static Pagination */}
//         <div className={styles.paginationWrapper}>
//           <Pagination
//             currentPage={currentPage}
//             totalPages={totalPages}
//             onPageChange={setCurrentPage}
//           />

//           <select
//             className={styles.inputsbtn}
//             value={limit}
//             onChange={(e) => {
//               setLimit(Number(e.target.value));
//               setCurrentPage(1);
//             }}
//           >
//             <option value={5}>5 rows</option>
//             <option value={10}>10 rows</option>
//             <option value={25}>25 rows</option>
//           </select>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PreBookedOrders;

import React, { useState } from "react";
import styles from "../../assets/scss/InventoryManagement/PriceCategory.module.scss";
import Pagination from "../../Components/Common/Pagination";
import { useGetTomorrowNeedsQuery } from "../../slices/admin/admin";
import { capitalize } from "../../utils/capitalize";

const PreBookedOrders = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);

  // 🔥 API CALL
  const { data, isLoading, isError } = useGetTomorrowNeedsQuery({
    offset: currentPage,
    limit,
  });

  const tomorrowData = data?.data || [];
  const totalOrders = data?.totalOrders || 0;
  const totalPages = Math.ceil(totalOrders / limit);

  return (
    <div className={styles.inventoryContainer}>
      <div className={styles.inventoryContainers}>
        <div className={styles.tableWrapper}>
          <table>
            <thead>
              <tr>
                <th>SR No</th>
                <th>Product Name</th>
                <th>Quantity (kg)</th>
              </tr>
            </thead>

            <tbody>
              {isLoading ? (
                <tr>
                  <td colSpan="3" style={{ textAlign: "center" }}>
                    Loading...
                  </td>
                </tr>
              ) : isError ? (
                <tr>
                  <td colSpan="3" style={{ textAlign: "center" }}>
                    Something went wrong
                  </td>
                </tr>
              ) : tomorrowData.length > 0 ? (
                tomorrowData.map((item, index) => (
                  <tr key={index}>
                    <td>{(currentPage - 1) * limit + index + 1}</td>
                    <td>{item.productName ? capitalize(item.productName) : '-'}</td>
                    <td>{item.totalQuantityKg} kg</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3" style={{ textAlign: "center" }}>
                    No data found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* 🔥 Backend Pagination */}
        <div className={styles.paginationWrapper}>
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
          />

          <select
            className={styles.inputsbtn}
            value={limit}
            onChange={(e) => {
              setLimit(Number(e.target.value));
              setCurrentPage(1);
            }}
          >
            <option value={5}>5 rows</option>
            <option value={10}>10 rows</option>
            <option value={25}>25 rows</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default PreBookedOrders;